// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".cntAddressForm .no-padding {\n  padding: 0;\n}", "",{"version":3,"sources":["webpack://./app/javascript/components/clients/form/AddressForm/address_form.scss"],"names":[],"mappings":"AACE;EACE,UAAA;AAAJ","sourcesContent":[".cntAddressForm {\n  .no-padding {\n    padding: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
